import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

export const NotificationGuideModuleAsyncComponent = AsyncComponent(async () => import('./notification-guide-module' /* webpackChunkName: "notification-guide-module" */ ));

export const NotificationGuideModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <NotificationGuideModuleAsyncComponent {...props}/>
  </React.Suspense>
}
